import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEnvelope,
    faPhone,
    faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FaLinkedin, FaGithub, FaTwitter, FaFacebook } from "react-icons/fa";
import emailjs from "emailjs-com";
import map from '../img/pngwing.com.png'

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
        emailjs.sendForm('service_q3aukuf', 'template_44mdv8f', e.target, 'LqX6V16EuPHT7VOF8')
            .then((result) => {
                alert('Message sent successfully!');
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                });
            }, (error) => {
                alert('Message sending failed, please try again.');
            });
    };


    return (
        <div id="contact" className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-gray-300 py-12 px-6">
            <div className="max-w-5xl mx-auto">
                <h2 className="text-4xl font-bold text-center text-teal-400 mb-6">
                    Contact Us
                </h2>
                <p className="text-center text-gray-400 mb-10">
                    Have a question or want to work together? Let’s connect!
                </p>

                <div className="grid md:grid-cols-2 gap-8">
                    <div className="backdrop-blur-md bg-gray-900 bg-opacity-50 p-6 rounded-lg shadow-lg">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label htmlFor="name" className="block text-sm mb-2">
                                    Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                    className="w-full p-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-teal-400"
                                    placeholder="Enter your name"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="email" className="block text-sm mb-2">
                                    Email Address <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    className="w-full p-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-teal-400"
                                    placeholder="Enter your email"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="subject" className="block text-sm mb-2">
                                    Subject
                                </label>
                                <input
                                    type="text"
                                    id="subject"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleInputChange}
                                    className="w-full p-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-teal-400"
                                    placeholder="Enter the subject (optional)"
                                />
                            </div>

                            <div className="mb-6">
                                <label htmlFor="message" className="block text-sm mb-2">
                                    Message <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    rows="4"
                                    className="w-full p-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-teal-400"
                                    placeholder="Enter your message"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-teal-400 text-gray-900 py-2 rounded-lg hover:bg-teal-500 transition duration-300"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>

                    <div className="space-y-6">
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="text-teal-400 text-xl mr-4"
                            />
                            <a
                                href="mailto:BheeshamKumar@example.com"
                                className="hover:text-teal-400 transition duration-300"
                            >
                                bheeshamKumar@example.com
                            </a>
                        </div>
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={faPhone}
                                className="text-teal-400 text-xl mr-4"
                            />
                            <span>+923 xxx xxxx</span>
                        </div>

                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                className="text-teal-400 text-xl mr-4"
                            />
                            <span>Mithi, Pakistan</span>
                        </div>

                        <div className="flex space-x-4 mt-4">
                            <a
                                href="https://www.linkedin.com/in/bheesham-mm"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaLinkedin className="text-2xl" />
                            </a>
                            <a
                                href="https://github.com/Bheesham-mm"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaGithub className="text-2xl" />
                            </a>
                            <a
                                href="https://www.facebook.com/profile.php?id=100076744035847"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaFacebook className="text-2xl" />
                            </a>
                        </div>

                        <div className="flex mt-12 items-center justify-center" style={{ height: '60%' }}>
                            <img src={map} className="object-cover" height={'100%'} alt="map_Image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
